<!-- @veltra/icons generated sha256:227c22af84682ff8 gen:8 source:src/svg/normal/zoom-out.svg -->
<script setup lang="ts">
defineOptions({ name: 'ZoomOut' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35M8 11h6" />
  </svg>
</template>
